import React from 'react';
import CSelect, { Error } from 'src/components/form/Select';
import { ActionMeta, Props } from 'react-select';
import _ from 'lodash';
import { ScenarioStatus, scenarioStatusOptions } from 'src/api/types';

interface ScenarioStatusSelectProps extends Omit<Props, 'value'> {
  value: string | undefined | null;
  onChange: (value: { label: string; value: string }, meta: ActionMeta<any>) => void;
  error?: boolean;
  helperText?: string | false;
  disabled?: boolean;
  placeholder?: string;
}

export const ScenarioStatusSelect: React.FC<ScenarioStatusSelectProps> = ({
  value,
  onChange,
  error,
  helperText,
  disabled,
  placeholder = 'Status',
}) => {
  return (
    <>
      <CSelect
        isDisabled={disabled}
        value={_.find(scenarioStatusOptions, (o) => o.value === value)}
        placeholder={placeholder}
        options={scenarioStatusOptions}
        onChange={onChange}
      />
      {error && helperText && <Error>{helperText}</Error>}
    </>
  );
};
